import { Pipe, PipeTransform, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'randomlyUniqueColor' })
export class RandomlyUniqueColorPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) { }
    transform(value: string) {
        if (value) {
            let num = 0;
            let len = value.length;
            for (let i = 0; i < len; i++) {
                num += value.charCodeAt(i);
            }
            let color = '#';
            color += this.pad((num * 3) % 100);
            color += this.pad((num * 5) % 100);
            color += this.pad((num * 7) % 100);
            return this.sanitized.bypassSecurityTrustStyle(color);
        }
        return this.sanitized.bypassSecurityTrustStyle('#000000');
    }
    pad(num: number) {
        if (num < 10) {
            return '0' + num;
        }
        return num.toString();
    }
}

@NgModule({
    declarations: [RandomlyUniqueColorPipe],
    exports: [RandomlyUniqueColorPipe]
})
export class RandomlyUniqueColorPipeModule{
}